export default function discard(error, action, ...args) {
  if (action.discard) return true;
  if (!('status' in error)) {
    return true;
  }
  return error.status >= 400 && error.status < 500;
}
